// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__35wU8","ActionBox":"styles_ActionBox__q6qHy"};